import Chart from "react-apexcharts";

export default function BarChart({ categories, series, colors, height = 300, horizontal = false, distributed = false, stacked = false }) {
  const options = {
    chart: { type: "bar", toolbar: { show: false }, fontFamily: "Inter, sans-serif", stacked },
    plotOptions: {
      bar: {
        borderRadius: 6,
        horizontal,
        columnWidth: "55%",
        distributed,
        dataLabels: { position: "top" },
      },
    },
    colors: colors || ["#7C3AED", "#3B82F6", "#06B6D4"],
    dataLabels: { enabled: false },
    xaxis: {
      categories,
      labels: { style: { fontSize: "11px", colors: "#64748B" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: { labels: { style: { fontSize: "11px", colors: "#64748B" } } },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 3 },
    legend: { show: !distributed, position: "top", horizontalAlign: "right", labels: { colors: "#334155" }, markers: { radius: 4 } },
  };
  return <Chart options={options} series={series} type="bar" height={height} />;
}
